import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { lighten } from 'polished';
import { DropdownToggle, Table, Tooltip } from 'reactstrap';
import Input from '~/components/Form/Input';
import { ReactComponent as Vector } from '../../assets/img/vector.svg';
import { Button } from 'takeat-design-system-ui-kit';
import { Tooltip as MuiTooltip, withStyles } from '@material-ui/core';

export const BillExplanation = styled.div`
  width: 100%;
`;

export const DivInformation = styled.div`
  width: 100%;
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  flex-direction: ${(props) => (props.hasTip ? 'column' : 'row')};
  border-top: 1px solid #EDEDED;
  padding-top: 8px;
`;

export const TipArea = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TotalArea = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const FinalDiv = styled.div`
  width: 100%;
  margin-left: 2%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
`;

export const Total = styled.div`
  display: flex;
  flex-direction: column;

  h4 {
    font-weight: 600 !important;
    margin: 0 !important;
  }
  span {
    color: #7a7a7a;
  }
`;

export const CustomTooltip = styled(Tooltip)`
  & .tooltip-inner {
    background-color: #222222 !important;
    color: #fff !important;
    width: 341px !important;
    max-width: none !important; /* Remove limite do Bootstrap */
  }

  & .tooltip-arrow::before {
    border-bottom-color: #222222 !important;
  }
`;

export const Paid = styled.div`
  right: 0;

  display: flex;
  flex-direction: column;
  span {
    color: grey;
  }
  h4 {
    margin: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const CategoriesTable = styled(Table)`
  width: 95%;
  min-width: 400px;
  align-items: center;
  border-collapse: separate;
  border-spacing: 0 20px;
  background: #fff6b3;
  filter: drop-shadow(0 0 4px rgba(0, 0, 0, 0.2));
  border-radius: 8px;
  padding: 0 30px;

  thead {
    border-bottom: 30px solid transparent;
    text-align: left;
    tr {
      th:last-child {
        text-align: right;
      }
    }
  }
  tbody {
    td {
      border-bottom: 1px solid #dee2e6;
    }
    td:last-child {
      text-align: right;
    }

    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
`;
export const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }

  margin-right: 10px;
`;

export const Delete = styled.button`
  border: none;
  background: none;

  &:active {
    border: none;
  }

  svg {
    color: ${(props) => props.theme.colors.secondary};
  }
`;

export const Actions = styled.div``;

export const StatusTag = styled.div.attrs((props) => ({
  color: props.color,
  backgroundcolor: lighten(0.33, props.color),
}))`
  color: ${(props) => props.color};
  background-color: ${(props) => props.backgroundcolor};
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  &::before {
    content: ' ';
    display: inline-block;
    position: relative;
    margin-right: 5px;
    width: 10px;
    height: 10px;
    background-color: ${(props) => props.color};
    border-radius: 50%;
  }
`;

export const PaymentDiv = styled.div`
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid #dee2e6;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PaymentTable = styled.table`
  width: 100%;
  margin-top: 10px;

  tr {
    font-size: 18px;
  }

  td {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const AddPaymentButton = styled.span.attrs((props) => ({
  color: props.color,
  backgroundcolor: lighten(0.33, props.color),
}))`
  background-color: ${(props) => props.backgroundcolor};
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  border: none;
  width: 60%;
  &:hover {
    text-decoration: none;
  }
  span {
    color: ${(props) => props.color};
  }
`;

export const TooltipPinpadStyled = styled.div`
  color: var(--Takeat-Colors-Neutrals-Grey-02, #7A7A7A);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  border-radius: 8px;
  background: var(--Takeat-Colors-Neutrals-White, #FFF);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.14), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  max-width: 216px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`

export const AddPaymentForm = styled.div`
  border: 1px solid #EDEDED;
  border-radius: 8px;        
  padding: 12px;

  > h4 {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 4px;
    color: #7A7A7A;
  }
  
  > div {
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    gap: 8px;
  }

  > main {
    width: 100%;
    height: auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    gap: 8px;
  }

  > section {
    background-color: #EDEDED;
    width: 100%;
    height: 1px;
    margin: 8px 0;
  }
`;

export const StyledMaquininhaButton = styled(Button)`
  transition: background-color 0.2s;
  background-color: #FFF;
  border: ${({ disabled }) => !disabled && '2px solid #c8131b'};
  color: #c8131b;
  width: 112px;
  
  &:hover, &:focus{
    background-color: #c8131b;
    color: #FFF;
  }
`;

// ${({isSelected}) => isSelected && css`
//   background-color: #c8131b;
//   color: #FFF;
// `}

export const DropDowxStyledButton = styled(Button)`
  color: #545454;
  padding-left: 28px;

  width: ${({ width }) => width && `${width}px !important`};

  svg path {
    transition: fill 0.2s ease !important;
  }
  
  svg {
    margin-left: 9px;
  }

  &:focus {
    svg {
      transform: rotate(180deg);
      transition: transform 0.2s ease, fill 0.2s ease;
    }

    svg path {

    }
  }
`

export const DropdownToggleStyled = styled(DropdownToggle)`
  ${({ autoWidth, width }) => width ? css`
    width: ${width}px;
  ` : (autoWidth ? css`
    width: auto !important;
  ` : css`
    width: 114px !important;
  `)}

  height: 40px !important;
  border-radius: 12px !important;
  color: #545454 !important;
  background: #F6F6F6 !important;
  margin: 0px !important;

  &:hover {
    transform: none !important;
    filter: contrast(0.8) !important;
    /* background: #c8131b !important; */
    color: #fff !important;

    svg path {
      transition: fill 0.2s ease !important;
      fill: #FFFFFF !important;
    }
  }

  &:focus {
    border: none !important;
    transform: none !important;
    /* filter: contrast(0.8) !important; */
    background: #c8131b !important;
    color: #fff !important;

    svg {
      transform: rotate(180deg);
      transition: transform 0.2s ease, fill 0.2s ease;
    }

    svg path {
      fill: #ffffff !important;
    }
  }

  svg path {
    transition: fill 0.2s ease !important;
    fill: #545454 !important;
    transform: rotate(0deg);
    transition: transform 0.2s ease;
  }
`;

export const VectorStyled = styled(Vector)`
  transition: fill 0.2s ease;

  ${DropdownToggleStyled}:hover &,
  ${DropdownToggleStyled}:focus & {
    fill: blue;
  }
`;

export const PaymentMethodButton = styled.button`
  width: 100px;
  height: 40px;
  color: #333;
  border: none;
  border-radius: 7px;
  transition: all 0.5s;

  font-size: 12px;
  line-height: 14px;

  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    border: 1px solid red;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const AddPaymentInput = styled(Input)`
  width: 90px;
  padding: 5px;
  font-size: 15px;
  border-radius: 10px;
  border-color: green;
`;

export const AddPaymentLink = styled.button`
  min-width: 33px;
  max-width: 33px;
  border-radius: 50%;
  margin-left: 10px;
  float: right;
  font-size: 18px;
  background-color: #28a745;
  text-align: center;
  color: white;
  border: none !important;

  &:focus {
    border: none;
  }
`;

export const DeletePaymentForm = styled.button`
  padding-bottom: 5px;
  color: red;
  cursor: pointer;
  border: none;
  background-color: transparent;
`;

export const InputButton = styled.div`
  right: 0;
  position: absolute;
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 40px;
`;

export const BlueButton = styled.button`
  border-radius: 5px;
  background-color: #3bd2c1;
  border: none;
  height: 38px;
  width: 149px;
  font-family: Poppins;
  font-weight: 700;
  font-size: 14px;

  &:disabled {
    cursor: not-allowed;
    background-color: #33333370;
  }
`;

export const RescueButton = styled.button`
  width: fit-content;
  border: none;
  border-radius: 7px;
  background-color: ${(props) => (props.disabled ? '#cdcdcd' : '#28a745')};
  color: #fff;
  padding: 5px 10px;
  height: 44px;
  transition: all 0.4s;
  cursor: ${(props) => props.disabled && 'default'};
`;

export const RescueContainer = styled.div`
  width: 100%;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: flex-start;

  [class*='InputContainer'] {
    margin: 0;
    width: 100%;
  }
`;

export const RescueDate = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 4px;
  width: 100%;

  [class*='InputContainer'] {
    width: 55%;
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 178px;
`;


export const TdStyled = styled.td`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-right: 10px;

  > span {
    display: block !important;
    overflow: "hidden" !important;
    white-space: "nowrap" !important;
    text-overflow: "ellipsis" !important;
    width: 180px;

    background-color: rebeccapurple;
  }

  > p {
    color: #94090F;
    background-color: #FAE8E9 !important;
    border-radius: 50px !important;
    width: fit-content !important;
    padding: 4px 12px !important;
    font-weight: 600 !important;
    font-family: Poppins !important;
    font-size: 11px !important;
    height: 24px !important;
  }
`